angular.module('lwNamb').controller('manageCarouselItemAddTrainingCtrl', ['$scope', '$localStorage',
  function($scope, $localStorage) {
    $localStorage.selectTrainingBackHash = undefined;
    $scope.onAddTraining = function(item) {
      localStorage.setItem("carouselTrainingItem", JSON.stringify(item));
      window.location = window.location.hash.split('/add-training')[0];
    };
  }
]);
